import { render, staticRenderFns } from "./WasteDocketView.vue?vue&type=template&id=3e3f897a&scoped=true&"
import script from "./WasteDocketView.vue?vue&type=script&lang=js&"
export * from "./WasteDocketView.vue?vue&type=script&lang=js&"
import style0 from "./WasteDocketView.vue?vue&type=style&index=0&id=3e3f897a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3f897a",
  null
  
)

export default component.exports